import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import FilterToggleGroup from 'ecosystem-marketplace-core/filters/components/filterToggleGroup'; // @ts-expect-error module is untyped

import LoadingWrapper from 'ecosystem-marketplace-core/components/LoadingWrapper';
import { isUninitialized } from 'ecosystem-marketplace-core/utils/requestState'; // @ts-expect-error module is untyped

import { getSearchTags } from '../../../actions/StorefrontActions';
import * as ThemeQueryField from '../../../constants/ThemeQueryField';
import { getSearchTagsOptions, getSearchTagsRequestState // @ts-expect-error module is untyped
} from '../../../selectors/storefront';

const LoadingComponent = () => /*#__PURE__*/_jsx(UILoadingSpinner, {
  size: "extra-small"
});

const SearchTagFilter = ({
  disabled,
  onChange,
  scrollable = true,
  value
}) => {
  const reduxDispatch = useDispatch();
  const searchTagsRequestState = useSelector(getSearchTagsRequestState);
  const searchTagsOptions = useSelector(getSearchTagsOptions);
  useEffect(() => {
    // TODO type selector instead of casting as RequestStateValue
    if (isUninitialized(searchTagsRequestState)) {
      reduxDispatch(getSearchTags());
    }
  }, [reduxDispatch, searchTagsRequestState]);
  return /*#__PURE__*/_jsx(LoadingWrapper, {
    LoadingComponent: LoadingComponent,
    requestStatus: searchTagsRequestState,
    children: /*#__PURE__*/_jsx(FilterToggleGroup, {
      disabled: disabled,
      multi: true,
      name: ThemeQueryField.TAGS,
      onChange: onChange,
      options: searchTagsOptions,
      scrollable: scrollable,
      value: value,
      virtualized: scrollable
    })
  });
};

export default SearchTagFilter;